import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FailureReasonBaseData } from "common";
import { AppSettings } from "projects/portal/src/app.settings";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FailureReasonService {

  private readonly baseUrl;

  constructor(private http: HttpClient, private settings: AppSettings) {
    this.baseUrl = `${this.settings.failurereasons.url}/failure-reasons`;
   }

  list(): Observable<FailureReasonBaseData[]> {
    return this.http.get<FailureReasonBaseData[]>(`${this.baseUrl}/options-to-select`);
  }
}
